import type { PerformanceSettings } from "./types";

export type VersusFeedbackMode = "full" | "reduced" | "off";

export interface VersusFeedbackPolicyInput {
  performance: Pick<PerformanceSettings, "sideFxMode" | "particleMode">;
  reducedMotionPreferred?: boolean;
  lowPowerMode?: boolean;
}

export interface VersusFeedbackPolicy {
  mode: VersusFeedbackMode;
  allowHeavyFx: boolean;
  allowDecorativeMotion: boolean;
  particleScalar: number;
}

export function resolveVersusFeedbackPolicy(input: VersusFeedbackPolicyInput): VersusFeedbackPolicy {
  const reducedMotionPreferred = input.reducedMotionPreferred === true;
  const lowPowerMode = input.lowPowerMode === true;
  const sideFxMode = input.performance.sideFxMode;
  const particleMode = input.performance.particleMode;

  if (sideFxMode === "OFF" || particleMode === "OFF") {
    return {
      mode: "off",
      allowHeavyFx: false,
      allowDecorativeMotion: false,
      particleScalar: 0
    };
  }

  if (reducedMotionPreferred || lowPowerMode || sideFxMode === "SUBTLE" || particleMode === "REDUCED") {
    return {
      mode: "reduced",
      allowHeavyFx: false,
      allowDecorativeMotion: true,
      particleScalar: 0.45
    };
  }

  return {
    mode: "full",
    allowHeavyFx: true,
    allowDecorativeMotion: true,
    particleScalar: 1
  };
}
